import {
    FETCH_RESERVATION_FAILURE, FETCH_RESERVATION_REQUEST, FETCH_RESERVATION_SUCCESS,
    FETCH_ROOM_AVAILABILITY_FAILURE, FETCH_ROOM_AVAILABILITY_REQUEST, FETCH_ROOM_AVAILABILITY_SUCCESS,
    FETCH_ROOM_FAILURE, FETCH_ROOM_REQUEST, FETCH_ROOM_SUCCESS,
    GET_ROOM_NUMBER_DETAIL_FAILURE,
    GET_ROOM_NUMBER_DETAIL_REQUEST,
    GET_ROOM_NUMBER_DETAIL_SUCCESS
} from "../../../Utils/Constant";

const initialState = {
    reserations: {},
    rooms: {},
    availability: {},
    roomDetail:{},
    loading: false,
    error: null,
};

export const frontDeskReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RESERVATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_RESERVATION_SUCCESS:
            return {
                ...state,
                reserations: action.payload,
                loading: false,
                error: null,
            };
        case FETCH_RESERVATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case FETCH_ROOM_AVAILABILITY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_ROOM_AVAILABILITY_SUCCESS:
            return {
                ...state,
                availability: action.payload,
                loading: false,
                error: null,
            };
        case FETCH_ROOM_AVAILABILITY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case FETCH_ROOM_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_ROOM_SUCCESS:
            return {
                ...state,
                rooms: action.payload,
                loading: false,
                error: null,
            };
        case FETCH_ROOM_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

            case GET_ROOM_NUMBER_DETAIL_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };
            case GET_ROOM_NUMBER_DETAIL_SUCCESS:
                return {
                    ...state,
                    roomDetail: action.payload,
                    loading: false,
                    error: null,
                };
            case GET_ROOM_NUMBER_DETAIL_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.payload,
                };
        default:
            return state;
    }
};
